"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/onboardingShared/TrialOffer.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _upgrade = require('shared/enum/upgrade');
var _cost = require('shared/services/cost');
var _supportUrls = require('shared/data/supportUrls');
var _Form = require('web/components/Form');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _components = require('web/screens/Signup/components');
var _AuthFrame = require('web/components/AuthFrame');


 const FREE_TEAM_MEMBER_CAP = 5; exports.FREE_TEAM_MEMBER_CAP = FREE_TEAM_MEMBER_CAP

































const zero = 0 

const ChatIcon = ({ stroke }) => (
  _react2.default.createElement('svg', {
    viewBox: "0 0 24 24"   ,
    fill: "none",
    stroke: stroke,
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}

    , _react2.default.createElement('path', { d: "M14 9a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v1a5 5 0 0 0 5 5h1l3 3v-3.4A5 5 0 0 0 14 10z"                       , __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} )
    , _react2.default.createElement('path', { d: "M17 8a5 5 0 0 1 5 5v1a5 5 0 0 1-5 5h-1l-3 3v-3"             , __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}} )
  )
)

const TeamIcon = ({ stroke }) => (
  _react2.default.createElement('svg', {
    viewBox: "0 0 24 24"   ,
    fill: "none",
    stroke: stroke,
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}

    , _react2.default.createElement('circle', { cx: "9", cy: "8", r: "3.2", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}} )
    , _react2.default.createElement('path', { d: "M3.5 19a5.5 5.5 0 0 1 11 0"       , __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}} )
    , _react2.default.createElement('circle', { cx: "16.8", cy: "9.4", r: "2.6", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}} )
    , _react2.default.createElement('path', { d: "M15.4 14.7a4.8 4.8 0 0 1 5.1 4.3"       , __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}} )
  )
)

const ExternalIcon = ({ stroke }) => (
  _react2.default.createElement('svg', {
    viewBox: "0 0 24 24"   ,
    fill: "none",
    stroke: stroke,
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}

    , _react2.default.createElement('circle', { cx: "12", cy: "12", r: "9", __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}} )
    , _react2.default.createElement('path', { d: "M3 12h18" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}} )
    , _react2.default.createElement('path', { d: "M12 3a14.5 14.5 0 0 1 0 18a14.5 14.5 0 0 1 0-18"            , __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}} )
  )
)

// One chip per selected product above the plan name.
const renderSelectionChips = (hasTeamChat, hasExternalChat) => (
  _react2.default.createElement('div', { className: "onboarding-payment--trial--chips", __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}
    , _react2.default.createElement('span', { className: "onboarding-payment--trial--chip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}, _react2.default.createElement(ChatIcon, { stroke: "currentColor", __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}} ), "Patient texting" )
    ,  hasTeamChat && (
      _react2.default.createElement('span', { className: "onboarding-payment--trial--chip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}, _react2.default.createElement(TeamIcon, { stroke: "currentColor", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}} ), "Team chat" )
    )
    ,  hasExternalChat && (
      _react2.default.createElement('span', { className: "onboarding-payment--trial--chip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}, _react2.default.createElement(ExternalIcon, { stroke: "currentColor", __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}} ), "External chat" )
    )
  )
)

const TrialOffer = ({
  prices,
  hasSms,
  hasTeamChat,
  hasExternalChat,
  selectedTier,
  onSelectedTierChange,
  isLoadingPricing,
  hasPricingError,
  onRetryPricing,
  isAvailable = true,
  isStarting = false,
  actionError,
  onBack,
  onStart,
  onSkip,
  onViewed,
  onSkipDialogViewed,
}) => {
  const [skipDialogOpen, setSkipDialogOpen] = _react.useState.call(void 0, false)
  // Opening the dialog moves focus into it, onto the safe action.
  _react.useEffect.call(void 0, () => {
    if (!skipDialogOpen) return undefined
    const timeout = setTimeout(() => {
      _optionalChain([document, 'access', _ => _.querySelector, 'call', _2 => _2('.onboarding-payment--skip-dialog--back'), 'optionalAccess', _3 => _3.focus, 'call', _4 => _4()])
    })
    return () => clearTimeout(timeout)
  }, [skipDialogOpen])
  const [pricingDialogOpen, setPricingDialogOpen] = _react.useState.call(void 0, false)
  const teamItem = prices.find(item => item.Type === _upgrade.SubscriptionItemType.TEAM)
  const smsItems = _react.useMemo.call(void 0, 
    () => prices
      .filter(item => item.Type === _upgrade.SubscriptionItemType.SMS)
      .sort((a, b) => a.Units - b.Units),
    [prices],
  )
  const selectedSmsItem = smsItems.find(item => item.Units.toString() === selectedTier)

  // With no on-screen tier picker the entry tier is the quote for everyone;
  // plan sizing moves to Settings → Plan after signup.
  _react.useEffect.call(void 0, () => {
    if (hasSms && !selectedSmsItem && smsItems[0]) {
      onSelectedTierChange(smsItems[0].Units.toString())
    }
  }, [hasSms, selectedSmsItem, smsItems, onSelectedTierChange])

  const priceReady =
    !isLoadingPricing &&
    !hasPricingError &&
    !!teamItem &&
    (!hasSms || !!selectedSmsItem)
  const isFreeTeamSelection = !hasSms
  const isBundle = !!(hasTeamChat || hasExternalChat)
  const teamCost = (_nullishCoalesce(_optionalChain([teamItem, 'optionalAccess', _5 => _5.UnitCost]), () => ( zero))) 
  const smsCost = (_nullishCoalesce(_optionalChain([selectedSmsItem, 'optionalAccess', _6 => _6.BaseCost]), () => ( zero))) 
  const estimate = (teamCost + (hasSms ? smsCost : zero)) 
  const action = _react.useMemo(() => ({
    selectedSmsItem,
    estimates: priceReady
      ? {
          has_sms: hasSms,
          estimated_seats: 1,
          estimated_patients_per_month: _optionalChain([selectedSmsItem, 'optionalAccess', _7 => _7.Units]),
          selected_sms_tier_units: _optionalChain([selectedSmsItem, 'optionalAccess', _8 => _8.Units]),
          estimated_monthly_cost_cents: isFreeTeamSelection ? 0 : estimate,
        }
      : {},
  }), [
    selectedSmsItem,
    priceReady,
    hasSms,
    isFreeTeamSelection,
    estimate,
  ])

  _react.useEffect.call(void 0, () => {
    if (priceReady) _optionalChain([onViewed, 'optionalCall', _9 => _9(action)])
  }, [priceReady, onViewed, action])

  const offerSkeleton = (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "onboarding-payment--skeleton onboarding-payment--skeleton--title" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 192}} )
      , _react2.default.createElement('div', { className: "onboarding-payment--skeleton onboarding-payment--skeleton--subtitle" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 193}} )
      , _react2.default.createElement('div', { className: "onboarding-payment--estimate", __self: this, __source: {fileName: _jsxFileName, lineNumber: 194}}
        , _react2.default.createElement('div', { className: "onboarding-payment--skeleton onboarding-payment--skeleton--lead" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 195}} )
        , _react2.default.createElement('div', { className: "onboarding-payment--skeleton onboarding-payment--skeleton--line" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 196}} )
        , _react2.default.createElement('div', { className: "onboarding-payment--skeleton onboarding-payment--skeleton--amount" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 197}} )
      )
    )
  )

  const errorSurfaces = (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  !isAvailable && (
        _react2.default.createElement('div', { className: "onboarding-payment--error-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 205}}
          , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 206}}, "You're offline. We're trying to reconnect — reload the page to try again."            )
          , _react2.default.createElement(_Form.Button, {
            isSecondary: true,
            onClick: () => window.location.reload(),
            className: "onboarding-payment--reload", __self: this, __source: {fileName: _jsxFileName, lineNumber: 207}}
, "Reload"

          )
        )
      )
      ,  isAvailable && hasPricingError && (
        _react2.default.createElement('div', { className: "onboarding-payment--error-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 217}}
          , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 218}}, "We couldn't load your plan details."     )
          , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: onRetryPricing, className: "onboarding-payment--retry", __self: this, __source: {fileName: _jsxFileName, lineNumber: 219}}, "Retry"

          )
        )
      )
      ,  isAvailable && actionError && _react2.default.createElement(_AuthFrame.Callout, { message: actionError, __self: this, __source: {fileName: _jsxFileName, lineNumber: 224}} ) 
    )
  )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "onboarding-payment--offer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 230}}
        ,  !priceReady && !hasPricingError && offerSkeleton 

         /* Team-chat-only (no SMS) signups never reach this component:
             acceptance commits the free plan directly and the authenticated
             leg redirects to the onboarding steps. Nothing renders here for
             a free selection by design. */ 

        ,  priceReady && !isFreeTeamSelection && (
          _react2.default.createElement('div', { className: "onboarding-payment--trial", __self: this, __source: {fileName: _jsxFileName, lineNumber: 239}}
            , _react2.default.createElement('h1', { className: "auth-title onboarding-payment--title" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 240}}, "Start your free 7-day trial"    )
            , _react2.default.createElement('p', { className: "auth-body onboarding-payment--subtitle" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 241}}, "You can cancel your trial at any time."       )

            , _react2.default.createElement('div', { className: "onboarding-payment--trial--split", __self: this, __source: {fileName: _jsxFileName, lineNumber: 243}}
              , _react2.default.createElement('div', { className: "onboarding-payment--trial--lockup", __self: this, __source: {fileName: _jsxFileName, lineNumber: 244}}
                ,  renderSelectionChips(hasTeamChat, hasExternalChat) 
                , _react2.default.createElement('p', { className: "onboarding-payment--trial--product", __self: this, __source: {fileName: _jsxFileName, lineNumber: 246}}
                  ,  isBundle ? 'BloomText Pro' : 'Patient Messaging' 
                )
                , _react2.default.createElement('p', { className: "onboarding-payment--trial--price", __self: this, __source: {fileName: _jsxFileName, lineNumber: 249}}, "Free for 7 days"   )
                , _react2.default.createElement('p', { className: "onboarding-payment--trial--after", __self: this, __source: {fileName: _jsxFileName, lineNumber: 250}}
                  , _react2.default.createElement('span', {
                    title: `Sized for up to ${_optionalChain([selectedSmsItem, 'optionalAccess', _10 => _10.Units, 'access', _11 => _11.toLocaleString, 'call', _12 => _12()])} patients/month, then ~${_cost.formatDisplayUnitCost.call(void 0, smsCost, _optionalChain([selectedSmsItem, 'optionalAccess', _13 => _13.Units]) || 1)} per additional patient. Change your plan anytime in Settings → Plan.`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 251}}
, "then ~"
                     ,  _cost.formatDisplayCost.call(void 0, estimate) , " / month"
                  )
                  ,  ' · ' 
                  , _react2.default.createElement('button', {
                    type: "button",
                    className: "onboarding-payment--pricing-link",
                    onClick: () => setPricingDialogOpen(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 257}}
, "How pricing works"

                  )
                )
              )
              , _react2.default.createElement('div', { className: "onboarding-payment--trial--what", __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}
                , _react2.default.createElement('h2', { className: "onboarding-payment--trial--what-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 267}}, "What you get"  )
                , _react2.default.createElement('ul', { className: "onboarding-payment--trial--list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 268}}
                  , _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 269}}, "Securely text message with patients"    )
                  , _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 270}}, "Your own dedicated clinic number"    )
                  , _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 271}}, "Nothing for patients to download"

                    , _react2.default.createElement('span', {
                      className: "onboarding-payment--trial--hint",
                      title: "Patients get standard text messages — no app to install, no passwords to remember."             , __self: this, __source: {fileName: _jsxFileName, lineNumber: 273}}
, "?"

                    )
                  )
                  ,  hasTeamChat
                    ? _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 281}}, "Chat with your team — included with every seat"        )
                    : _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 282}}, "Built-in team chat for your staff"     ) 
                  ,  hasExternalChat && _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 283}}, "Invite unlimited external collaborators"   ) 
                )
              )
            )

            ,  errorSurfaces 

            , _react2.default.createElement('div', { className: "onboarding-payment--actions onboarding-payment--trial--actions" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 290}}
              ,  onBack && _react2.default.createElement(_components.BackArrow, { onClick: onBack, disabled: isStarting, __self: this, __source: {fileName: _jsxFileName, lineNumber: 291}} ) 
              , _react2.default.createElement(_Form.Button, {
                isLoading: isStarting,
                isDisabled: !isAvailable,
                onClick: () => onStart(action),
                className: "onboarding-payment--start", __self: this, __source: {fileName: _jsxFileName, lineNumber: 292}}

                ,  actionError ? 'Try again' : 'Start my free trial' 
              )
            )
            , _react2.default.createElement('p', { className: "onboarding-payment--trial--skip-line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 301}}, "Not ready?"
               ,  ' ' 
              , _react2.default.createElement('button', {
                type: "button",
                className: "onboarding-payment--skip-link",
                disabled: isStarting,
                onClick: () => {
                  _optionalChain([onSkipDialogViewed, 'optionalCall', _14 => _14(action)])
                  setSkipDialogOpen(true)
                }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 303}}
, "Skip for now"

              )
              ,  ' ' , "— you can upgrade anytime."
            )
          )
        )

        ,  !priceReady && errorSurfaces 
      )
      , _react2.default.createElement(_Modal2.default, {
        isOpen: skipDialogOpen,
        onClose: () => setSkipDialogOpen(false),
        title: "Skip your free trial?"   ,
        size: "xs",
        className: "onboarding-payment--skip-dialog", __self: this, __source: {fileName: _jsxFileName, lineNumber: 321}}

        , _react2.default.createElement('p', { className: "onboarding-payment--skip-dialog--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 328}}, "If you skip, you'll be on the free plan only — you can still chat with your coworkers. Starting your trial lets you test SMS messaging before paying for the upgrade."



        )
         /* The safe action carries the primary style and the right-hand
             slot; skipping is the warning-colored escape hatch. */ 
        , _react2.default.createElement('div', { className: "onboarding-payment--skip-dialog--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 335}}
          , _react2.default.createElement(_Form.Button, {
            isDanger: true,
            onClick: () => {
              setSkipDialogOpen(false)
              onSkip(action)
            },
            className: "onboarding-payment--skip-dialog--confirm", __self: this, __source: {fileName: _jsxFileName, lineNumber: 336}}
, "Skip anyway"

          )
          , _react2.default.createElement(_Form.Button, {
            onClick: () => setSkipDialogOpen(false),
            className: "onboarding-payment--skip-dialog--back", __self: this, __source: {fileName: _jsxFileName, lineNumber: 346}}
, "Go back"

          )
        )
      )
      , _react2.default.createElement(_Modal2.default, {
        isOpen: pricingDialogOpen,
        onClose: () => setPricingDialogOpen(false),
        title: "How our pricing works"   ,
        className: "onboarding-payment--pricing-modal", __self: this, __source: {fileName: _jsxFileName, lineNumber: 354}}

        , _react2.default.createElement('div', { className: "onboarding-payment--pricing-dialog", __self: this, __source: {fileName: _jsxFileName, lineNumber: 360}}
          , _react2.default.createElement('div', { className: "onboarding-payment--pricing-dialog--row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 361}}
            , _react2.default.createElement('div', { className: "onboarding-payment--pricing-dialog--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 362}}
              , _react2.default.createElement('span', { className: "onboarding-payment--pricing-dialog--icon onboarding-payment--pricing-dialog--icon--seats" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 363}}
                , _react2.default.createElement(TeamIcon, { stroke: "#6257c4", __self: this, __source: {fileName: _jsxFileName, lineNumber: 364}} )
              )
              , _react2.default.createElement('p', { className: "onboarding-payment--pricing-dialog--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 366}}, "Base seat cost"  )
              , _react2.default.createElement('span', { className: "onboarding-payment--pricing-dialog--tag onboarding-payment--pricing-dialog--tag--required" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 367}}, "Required"

              )
            )
            , _react2.default.createElement('p', { className: "onboarding-payment--pricing-dialog--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 371}}
              ,  _cost.formatDisplayCost.call(void 0, teamCost) , " per user / month. Every seat includes secure team chat with your coworkers — team chat is never a separate charge."


            )
          )
          , _react2.default.createElement('div', { className: "onboarding-payment--pricing-dialog--row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 377}}
            , _react2.default.createElement('div', { className: "onboarding-payment--pricing-dialog--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 378}}
              , _react2.default.createElement('span', { className: "onboarding-payment--pricing-dialog--icon onboarding-payment--pricing-dialog--icon--texting" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 379}}
                , _react2.default.createElement(ChatIcon, { stroke: "#b8860b", __self: this, __source: {fileName: _jsxFileName, lineNumber: 380}} )
              )
              , _react2.default.createElement('p', { className: "onboarding-payment--pricing-dialog--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 382}}, "Patient texting add-on"  )
              , _react2.default.createElement('span', { className: "onboarding-payment--pricing-dialog--tag", __self: this, __source: {fileName: _jsxFileName, lineNumber: 383}}, "Optional")
            )
            , _react2.default.createElement('p', { className: "onboarding-payment--pricing-dialog--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 385}}, "Adds your own clinic number so patients text you back — no app for them to install. Priced by how many patients you message each month. Change tiers anytime in Settings → Plan."



            )
          )
          , _react2.default.createElement('table', { className: "onboarding-payment--pricing-dialog--tiers", __self: this, __source: {fileName: _jsxFileName, lineNumber: 391}}
            , _react2.default.createElement('thead', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 392}}
              , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 393}}
                , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 394}}, "Patients you message / month"    )
                , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 395}}, "Price / month"  )
              )
            )
            , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 398}}
              ,  smsItems.map(item => (
                _react2.default.createElement('tr', {
                  key: item.Units,
                  className: item.Units === _optionalChain([selectedSmsItem, 'optionalAccess', _15 => _15.Units]) ? 'is-selected' : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 400}}

                  , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 404}}, "Up to "
                      ,  item.Units.toLocaleString() 
                    ,  item.Units === _optionalChain([selectedSmsItem, 'optionalAccess', _16 => _16.Units]) && (
                      _react2.default.createElement('span', { className: "onboarding-payment--pricing-dialog--yours", __self: this, __source: {fileName: _jsxFileName, lineNumber: 407}}, "your quote" )
                    )
                  )
                  , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 410}},  _cost.formatDisplayCost.call(void 0, (_nullishCoalesce(item.BaseCost, () => ( zero))) ) )
                )
              ))
            )
          )
          , _react2.default.createElement('p', { className: "onboarding-payment--pricing-dialog--tier-note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 415}}, "Message each patient as much as you like — they only count once per month."


          )
          , _react2.default.createElement('div', { className: "onboarding-payment--pricing-dialog--row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 419}}
            , _react2.default.createElement('div', { className: "onboarding-payment--pricing-dialog--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 420}}
              , _react2.default.createElement('span', { className: "onboarding-payment--pricing-dialog--icon onboarding-payment--pricing-dialog--icon--external" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 421}}
                , _react2.default.createElement(ExternalIcon, { stroke: "#2e7d32", __self: this, __source: {fileName: _jsxFileName, lineNumber: 422}} )
              )
              , _react2.default.createElement('p', { className: "onboarding-payment--pricing-dialog--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 424}}, "External communication" )
              , _react2.default.createElement('span', { className: "onboarding-payment--pricing-dialog--tag onboarding-payment--pricing-dialog--tag--free" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 425}}, "Included free"

              )
            )
            , _react2.default.createElement('p', { className: "onboarding-payment--pricing-dialog--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 429}}, "Message healthcare professionals outside your organization for free — it's simply part of BloomText."


            )
          )
          , _react2.default.createElement('div', { className: "onboarding-payment--pricing-dialog--summary", __self: this, __source: {fileName: _jsxFileName, lineNumber: 434}}
            , _react2.default.createElement('p', { className: "onboarding-payment--pricing-dialog--total", __self: this, __source: {fileName: _jsxFileName, lineNumber: 435}}, "Your estimate: 1 seat"
                 ,  hasSms && selectedSmsItem ? ' + patient texting' : '' , " ≈" ,  ' ' 
              , _react2.default.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 437}},  _cost.formatDisplayCost.call(void 0, estimate) , " / month"  ), " after the free trial."

            )
            , _react2.default.createElement('p', { className: "onboarding-payment--pricing-dialog--trial-note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 440}}, "Try everything free for 7 days — cancel during the trial and you pay nothing, with a full refund if anything was charged."


            )
          )
          , _react2.default.createElement('div', { className: "onboarding-payment--pricing-dialog--links", __self: this, __source: {fileName: _jsxFileName, lineNumber: 445}}
            , _react2.default.createElement('a', {
              className: "onboarding-payment--pricing-dialog--full-link",
              href: _supportUrls.pricingUrl,
              target: "_blank",
              rel: "noopener noreferrer" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 446}}
, "See our full pricing page"

            )
            , _react2.default.createElement('p', { className: "onboarding-payment--pricing-dialog--demo", __self: this, __source: {fileName: _jsxFileName, lineNumber: 454}}, "Want to learn more about how this works?"
                     ,  ' ' 
              , _react2.default.createElement('a', { href: _supportUrls.scheduleMeetingUrl, target: "_blank", rel: "noopener noreferrer" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 456}}, "Schedule a demo"

              )
              ,  ' ' , "with us."
            )
          )
        )
      )
    )
  )
}

exports. default = TrialOffer
